// packages/shared/src/schemas/category.ts
import { z } from 'zod'
import { categorySlugFromName } from '../lib/category-slug.js'

export const CategorySlugSchema = z
  .string()
  .min(1, 'Slug is required')
  .max(50)
  .transform((value) => value.trim().toUpperCase())
  .pipe(
    z
      .string()
      .regex(/^[A-Z0-9]+(?:-[A-Z0-9]+)*$/, 'Slug must be uppercase letters, numbers, and hyphens'),
  )

export const CategorySchema = z.object({
  id: z.string(),
  slug: CategorySlugSchema,
  name: z.string(),
  navLabel: z.string().nullable(),
  description: z.string().nullable(),
  imageUrl: z.string().nullable().optional(),
  sortOrder: z.number().int(),
  isActive: z.boolean(),
  productCount: z.number().int().min(0).optional(),
  createdAt: z.string(),
  updatedAt: z.string(),
})

export const CreateCategoryInput = z.object({
  name: z.string().min(1, 'Name is required').max(120).trim(),
  slug: CategorySlugSchema.optional(),
  navLabel: z.string().max(120).trim().optional(),
  description: z.string().max(500).trim().optional(),
  imageUrl: z.string().max(500).trim().optional().nullable(),
  sortOrder: z.number().int().min(0).default(0),
  isActive: z.boolean().default(true),
})

export const UpdateCategoryInput = CreateCategoryInput.omit({ slug: true }).partial()

export const CategoryManageQuerySchema = z.object({
  page: z.coerce.number().int().min(1).default(1),
  pageSize: z.coerce.number().int().min(1).max(100).default(20),
})

export type Category = z.infer<typeof CategorySchema>
export type CreateCategoryInput = z.infer<typeof CreateCategoryInput>
export type UpdateCategoryInput = z.infer<typeof UpdateCategoryInput>

export { categorySlugFromName }
